import { render, staticRenderFns } from "./GroupDetailsAnimatedIcon.vue?vue&type=template&id=48b1636f&scoped=true"
import script from "./GroupDetailsAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./GroupDetailsAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1636f",
  null
  
)

export default component.exports